import { render, staticRenderFns } from "./VehicleDocumentsListComponent.vue?vue&type=template&id=e38844a8&"
import script from "./VehicleDocumentsListComponent.vue?vue&type=script&lang=js&"
export * from "./VehicleDocumentsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports